import React from 'react';

export default ({text = "Email Address:",email = "", isBr}) => (
    <a href ={`mailto: ${email}`}>
        {text + ' '}
        {isBr && <br/>}
        {email}
    </a>
);
